import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useRouteMatch } from 'react-router-dom';

// constants
import appRoutes from '../../../../app-routes';
import { PASSWORD_FORM_MODES } from '../../../../constraints';

// helpers
import { removeUndefinedValues } from '../../../../helpers/removeUndefinedValues';

// hooks
import { useSingleUser } from '../../hooks/useSingleUser';
import { useSetUserPassword } from '../../hooks/useSetUserPassword';

// Components
import PasswordForm from '../../components/PasswordForm';
import { SuccessModal as CustomSuccessModal } from '../../../../components/SuccessModal';
import { UniCardRowCol } from '../../../../components/UniCardContent/UniCardContent';
import { Layout as LayoutModule, Utils, Modal as ModalModule } from 'billon-ui';

const { Loader: LoaderModule } = Utils;
const { PageLoader } = LoaderModule;
const { Content: ContentModule } = LayoutModule;
const { Content } = ContentModule;
const { CreateModal } = ModalModule;

const SetTemporaryPasswordPage = () => {
  const history = useHistory();

  const [temporaryPasswordModalOpen, setTemporaryPasswordModalOpen] =
    useState(true);
  const [successModal, setSuccessModal] = useState(false);
  const [reasons, setReasons] = useState([]);

  const { params } = useRouteMatch(appRoutes.TEMPORATY_PASSWORD_SET);
  const { id } = params;
  const { data: user, isLoading: isUserLoading } = useSingleUser({ id: id });

  const handleCloseTemporaryPasswordModal = () => {
    setTemporaryPasswordModalOpen(false);
  };

  const handleSetPasswordSuccess = () => {
    handleCloseTemporaryPasswordModal();
    setSuccessModal(true);
  };

  const handleSetPasswordFailure = ({ response }) => {
    setReasons(response?.data?.reasons || []);
  };

  const handleOnCloseSuccess = () => {
    setSuccessModal(false);
    history.push(appRoutes.USERS_BLANK);
  };

  const { mutate: setPassword, isLoading } = useSetUserPassword({
    onSuccess: handleSetPasswordSuccess,
    onError: handleSetPasswordFailure,
  });

  const handleSuccess = (values) => {
    const { password } = values || {};
    setPassword({ id: id, data: removeUndefinedValues({ password }) });
  };

  const formConfig = {
    mode: PASSWORD_FORM_MODES.PASSWORD_SET,
    handleSuccess: handleSuccess,
    titleId: 'Set password',
    passwordLabelId: 'Password',
    repeatPasswordLabelId: 'Repeat password',
    submitMessageId: 'Next',
  };

  if (isUserLoading) {
    return (
      <Content fluid>
        <PageLoader />
      </Content>
    );
  }

  return (
    <>
      <CreateModal
        isOpen={temporaryPasswordModalOpen}
        onSuccess={handleSuccess}
        onCancel={handleCloseTemporaryPasswordModal}
        initialValues={{}}
        createMessage={
          <FormattedMessage
            id="Set temporary password"
            defaultMessage="Set temporary password"
          />
        }
      >
        <UniCardRowCol>
          <PasswordForm
            formConfig={formConfig}
            role={user.role}
            deliveredReasons={reasons}
            deliveredLoading={isLoading}
          />
        </UniCardRowCol>
      </CreateModal>
      <CustomSuccessModal
        isOpen={successModal}
        toggle={handleOnCloseSuccess}
        onClose={handleOnCloseSuccess}
        closeIconEnabled={false}
      >
        <FormattedMessage
          id={'Password has been set'}
          defaultMessage={'Password has been set'}
        />
      </CustomSuccessModal>
    </>
  );
};

export default SetTemporaryPasswordPage;
